const CATEGORY_INPUT_SELECTOR =
	'.tribe-filter-bar-c-filter input[data-js="tribe-filter-bar-c-dropdown-input"][name="tribe_eventcategory[]"]';
const OPEN_RESULTS_LIST_SELECTOR = ".select2-results__options";
const CLEAR_BUTTON_TEXT_SELECTOR = ".tribe-filter-bar-c-clear-button__text";
const ACTIVE_CLASSES = ["active", "is-active-option"];

export const initEventArchiveUI = () => {
	const root = document.querySelector(".post-type-archive-tribe_events.tribe-js");
	if (!root) return;

	syncCategoryDropdownActiveOption();
	bindTecHooks();

	root.addEventListener("click", handleUiInteraction, true);
	root.addEventListener("keyup", handleUiInteraction, true);
};

const bindTecHooks = () => {
	const $ = window.jQuery;
	if (!$) return;

	const viewSelector = '[data-js="tribe-events-view"]';

	$(document).on("afterSetup.tribeEvents afterAjaxSuccess.tribeEvents", viewSelector, () => {
		window.requestAnimationFrame(syncCategoryDropdownActiveOption);
	});

	$(document).on("change select2:open select2:close select2:select select2:unselect", CATEGORY_INPUT_SELECTOR, () => {
		window.requestAnimationFrame(syncCategoryDropdownActiveOption);
	});
};

const handleUiInteraction = (event) => {
	const trigger = event.target.closest(
		".tribe-filter-bar-c-filter, .select2-results__option, .select2-selection__choice, .select2-selection__clear",
	);

	if (!trigger) return;

	window.setTimeout(syncCategoryDropdownActiveOption, 0);
};

const syncCategoryDropdownActiveOption = () => {
	const input = document.querySelector(CATEGORY_INPUT_SELECTOR);
	if (!input) return;

	const hasSelectedCategory = `${input.value ?? ""}`.trim() !== "";
	setAllButtonActiveState(!hasSelectedCategory);

	const options = getOpenCategoryDropdownOptions(input);
	if (!options.length) return;

	if (!hasSelectedCategory) {
		options.forEach((option) => {
			ACTIVE_CLASSES.forEach((className) => {
				option.classList.remove(className);
			});
		});

		return;
	}

	const selectedLabel = getCurrentCategoryLabel();
	if (!selectedLabel) return;

	let matched = false;

	options.forEach((option) => {
		const optionText = normalizeText(option.textContent);
		const isActive = !matched && optionText === selectedLabel;

		ACTIVE_CLASSES.forEach((className) => {
			option.classList.toggle(className, isActive);
		});

		if (isActive) {
			matched = true;
		}
	});
};

const setAllButtonActiveState = (isActive) => {
	const clearButtons = document.querySelectorAll(CLEAR_BUTTON_TEXT_SELECTOR);
	if (!clearButtons.length) return;

	clearButtons.forEach((buttonText) => {
		ACTIVE_CLASSES.forEach((className) => {
			buttonText.classList.toggle(className, isActive);
		});
	});
};

const getOpenCategoryDropdownOptions = (input) => {
	const lists = document.querySelectorAll(OPEN_RESULTS_LIST_SELECTOR);
	if (!lists.length) return [];

	const inputId = input.getAttribute("id");
	if (!inputId) {
		return Array.from(document.querySelectorAll(".select2-container--open .select2-results__option"));
	}

	const matchedList = Array.from(lists).find((list) => {
		const listId = list.getAttribute("id") || "";
		return listId.includes(`select2-${inputId}-results`);
	});

	if (!matchedList) return [];

	return Array.from(matchedList.querySelectorAll(".select2-results__option"));
};

const getCurrentCategoryLabel = () => {
	const input = document.querySelector(CATEGORY_INPUT_SELECTOR);
	if (!input) return "";

	const selectedValue = `${input.value ?? ""}`.trim();
	const options = getDropdownOptions(input);

	if (!options.length) return "";

	const selectedOption = options.find((option) => `${option.id ?? ""}`.trim() === selectedValue);
	if (selectedOption?.text) {
		return normalizeText(selectedOption.text);
	}

	const allOption = options.find((option) => `${option.id ?? ""}`.trim() === "");
	if (allOption?.text) {
		return normalizeText(allOption.text);
	}

	return normalizeText(options[0]?.text || "");
};

const getDropdownOptions = (input) => {
	const rawOptions = input.getAttribute("data-options");
	if (!rawOptions) return [];

	try {
		const parsed = JSON.parse(rawOptions);
		return Array.isArray(parsed) ? parsed : [];
	} catch (error) {
		return [];
	}
};

const normalizeText = (value) => `${value || ""}`.replace(/\s+/g, " ").trim().toLowerCase();
